<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Info</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse"
                        >
                            <i
                                :class="[collapse ? 'fa-minus' : 'fa-plus']"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div>
                    <vue-slide-up-down
                        :active="collapse"
                        :duration="durationCollapse"
                    >
                        <div
                            v-if="provider.id"
                            class="box-body"
                        >
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Name:</strong>
                                    <p>{{ provider.name }}</p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Type:</strong>
                                    <p>
                                        {{ campaignTypes[provider.campaign_type_id] }}
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Created At:</strong>
                                    <p>{{ provider.created_at }}</p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Updated At:</strong>
                                    <p>{{ provider.updated_at }}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Active:</strong>
                                    <p>
                                        <value-yes-no :value="provider.active" />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Use Numbers:</strong>
                                    <p>
                                        <value-yes-no :value="provider.use_numbers" />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Use Surcharge Fee:</strong>
                                    <p>
                                        <value-yes-no :value="provider.use_surcharge_fee" />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Use Short codes:</strong>
                                    <p>
                                        <value-yes-no :value="provider.sc" />
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Use TFN:</strong>
                                    <p>
                                        <value-yes-no :value="provider.use_tfn" />
                                    </p>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-3">
                                    <strong>Use Setting Plus:</strong>
                                    <p>
                                        <value-yes-no :value="provider.use_setting_plus" />
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <strong>Predefined Body Categories ({{ pBodyCategoriesCount }}):</strong>
                                    <div v-if="provider.p_body_categories.length">
                                        <p>
                                            <span
                                                v-for="(category, index) in provider.p_body_categories"
                                                :key="index"
                                            >
                                                <a
                                                    :class="ifActive(category.active, 'text-red')"
                                                    :href="getRoute(category.id, 'pBodiesCategoriesShow')"
                                                    :title="ifActive(category.active, 'Disabled')"
                                                >
                                                    {{ category.name }}
                                                </a>
                                                <span v-if="index !== provider.p_body_categories.length - 1">,</span>
                                            </span>
                                        </p>
                                    </div>
                                    <p v-else>
                                        <span class="text-red">No Predefined Body Categories selected!</span>
                                    </p>
                                </div>
                                <div class="col-xs-12">
                                    <strong> Badwords ({{ badWordsCount }}): </strong>
                                    <div v-if="provider.badwords.length">
                                        <p>
                                            <span
                                                v-for="(badword, index) in provider.badwords"
                                                :key="index"
                                            >
                                                <code>{{ badword.value }}</code>
                                                <span v-if="index !== provider.badwords.length - 1">,</span>
                                            </span>
                                        </p>
                                    </div>
                                    <p v-else>
                                        <span class="text-red"> No Badwords attached! </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </vue-slide-up-down>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../../subcomponents/ValueYesNo';

export default {
    components: {
        ValueYesNo,
    },
    props: {
        providerId: {
            type: [String, Number],
            default: null,
        },
    },
    data: function () {
        return {
            provider: {},
            campaignTypes: {},
            pBodyCategoriesCount: '',
            badWordsCount: '',
            route: {
                group: '/category-groups/:id:',
                pBodiesCategoriesShow: '/predefined-bodies/categories/:id:',
            },
            collapse: true,
            durationCollapse: 700,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            axios
                .get('/apis/providers/' + this.providerId + '/data')
                .then((response) => {
                    this.provider = response.data.provider;
                    this.pBodyCategoriesCount = response.data.pBodyCategoriesCount;
                    this.badWordsCount = response.data.badWordsCount;
                    this.campaignTypes = response.data.campaignTypes;
                })
                .catch(() => {});
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        ifActive: function (value, text) {
            return value ? '' : text;
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
